module.exports = __webpack_public_path__ + "static/giantTube-08f971a34ed586097f5bd8f2cb106d99.jpg";